<script lang="ts">
    import {onMount} from "svelte";
    import TipsMessageAreaView from "../../../../../component/common/Message/TipsMessageAreaView.svelte";
    import {BinaryTable} from "../../../../../lib/Table/BinaryTable";

    export let binary;

    $: message = (() => {
        if (binary == null) {
            return null;
        }
        const status = binary.status;
        switch (status) {
            case BinaryTable.Status.Building:
                return 'このバイナリはビルド中です';
            case BinaryTable.Status.Cancel:
                return 'このバイナリはキャンセルされています';
            case BinaryTable.Status.BuildError:
                return 'このバイナリはビルドエラーです';
        }
        return null;
    })();

    $: type = (() => {
        if (binary == null) {
            return 'information';
        }
        const status = binary.status;
        switch (status) {
            case BinaryTable.Status.BuildError:
            case BinaryTable.Status.Cancel:
                return 'warning';
        }
        return 'information';
    })();

    onMount(() => {
    });


</script>

<div class="binary-status-notice-view">
    {#if message != null}
        <TipsMessageAreaView type={type}>
            { message }
        </TipsMessageAreaView>
    {/if}
</div>

<style lang="scss">
    .binary-status-notice-view {

    }
</style>